/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.
 
This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.
 
License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.
 
This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.
 
For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "eworldes-ui-toolkit-v1.1.0";

interface ReferenceDialogProps {
    onClose: () => void;
    referenceText: string | null;
}

export function ReferenceDialog(props: ReferenceDialogProps) {
    const { onClose, referenceText } = props;
    if (!referenceText) return null;

    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            onClose={onClose}
            open={!!referenceText}
            title=""
            secondaryactionlabel=""
            primaryactionlabel=""
            bodycontent=""
            sx={{
                "& .MuiDialog-paper": {
                    borderRadius: 2,
                },
            }}
        >
            <DialogTitle sx={{ ml: 1, fontWeight: "bold" }}>
                Selected Reference Section
            </DialogTitle>
            <DialogContent
                sx={{ whiteSpace: "pre-wrap", fontFamily: "sans-serif", m: 1 }}
            >
                {referenceText}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="text">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
